<template>
    <!--
        Rodapé de paginação padrão para telas que paginam no servidor com filtros próprios
        (o EcTabelaListagem já traz o seu). Recebe o paginator do Laravel e emite
        "ir" com o número da página escolhida.
        Estilos em resources/sass/_tabelas.scss (.ec-listagem__rodape / .ec-paginacao).
    -->
    <div v-if="paginacao && paginacao.total > 0" class="ec-listagem__rodape ec-paginacao">
        <span class="ec-listagem__info">
            Mostrando <b>{{ paginacao.from }}–{{ paginacao.to }}</b> de <b>{{ paginacao.total }}</b> {{ rotuloItens }}
        </span>

        <nav v-if="paginacao.last_page > 1" aria-label="Paginação">
            <ul class="pagination pagination-sm mb-0">
                <li v-for="(link, key) in links" :key="key" class="page-item" :class="{ active: link.active, disabled: !link.url || carregando }">
                    <button
                        type="button"
                        class="page-link"
                        :disabled="!link.url || carregando"
                        :aria-current="link.active ? 'page' : null"
                        :aria-label="link.rotulo"
                        @click="irPara(link)"
                        v-html="link.label"
                    ></button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        // paginator do Laravel (from, to, total, last_page, links)
        paginacao: { type: Object, default: null },
        rotuloItens: { type: String, default: 'registros' },
        carregando: { type: Boolean, default: false },
    },
    computed: {
        // links do Laravel com "Anterior/Próxima" traduzidos e rótulo acessível
        links() {
            return (this.paginacao.links || []).map((link, i, todos) => {
                let label = link.label;
                let rotulo = 'Página ' + link.label;
                if (i === 0) { label = '&lsaquo;'; rotulo = 'Página anterior'; }
                if (i === todos.length - 1) { label = '&rsaquo;'; rotulo = 'Próxima página'; }
                return Object.assign({}, link, { label, rotulo });
            });
        },
    },
    methods: {
        irPara(link) {
            if (!link.url || link.active || this.carregando) return;
            const pagina = parseInt(new URL(link.url, window.location.origin).searchParams.get('page'), 10) || 1;
            this.$emit('ir', pagina, link.url);
        },
    },
};
</script>
